import React from 'react';
import { StarRating } from '../../../components/Sessions/Elements/StarRating';
import user from '../../../../images/no_user_placeholder.png';
import { formatDate } from '../../../../utils/utils';

export const TutorReviewsSection = ({ reviews = [] }) => {
    console.log(reviews)
    return (
        <div className="card shadow-sm mb-4">
            <div className="card-header bg-white py-3">
                <h4 className="card-title mb-0">Student Reviews</h4>
            </div>
            <div className="card-body p-3 overflow-y-scroll" style={{ maxHeight: "748px" }}>
                {reviews.length > 0 ? reviews.map((review) => (
                    <div key={review.id} className="border-bottom p-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap">
                            <img
                                src={review.reviewerImage ? `${process.env.REACT_APP_IMAGE_PATH}${review.reviewerImage}` : user}
                                alt={review.reviewerFullName}
                                className="rounded-circle me-3"
                                width="40"
                                height="40"
                                onError={(e) => { e.target.src = user; }}
                            />
                            <div className="flex-grow-1">
                                <h6 className="mb-0">{review.reviewerFullName}</h6>
                                <small className="text-muted">{formatDate(review.createdDate)}</small>
                            </div>
                            <div className="mt-2 mt-md-0 d-flex flex-row align-items-center">
                                <StarRating value={review.count} />
                                 <span className="fw-bold text-dark ms-2 mt-2">
                                    {review.count.toFixed(1)}
                                </span>
                            </div>
                        </div>
                        <p>{review.comment}</p>
                        {review.subject && (
                            <span className="badge bg-secondary">{review.subject}</span>
                        )}
                    </div>
                )) : (
                    <div className="text-center p-3 text-muted">No reviews yet</div>
                )}
            </div>
        </div>
    );
};